import { useState, useEffect } from 'react';

const getDeviceType = () => {

  if (typeof window === 'undefined') {
    return 'Desktop'; // Domyślnie dla Server-Side Rendering
  }
  const ua = navigator.userAgent;
  
  if (/iPad|iPhone|iPod/.test(ua)) {
    return 'iOS';
  }
  if (/Android/.test(ua)) {
    return 'Android';
  }
  return 'Desktop';
};

/**
 * Hook do wykrywania typu urządzenia (iOS, Android, Desktop)
 * Działa tylko po stronie klienta.
 */
export const useDeviceType = () => {
  // UWAGA: To może powodować błąd "Hydration failed" w Next.js/Gatsby,
  // ale wyeliminuje mignięcie przycisku dla użytkownika.
  const [deviceType, setDeviceType] = useState(() => {
      if (typeof window !== 'undefined') {
          return getDeviceType(); // Sprawdzamy od razu przy inicjalizacji
      }
      return 'Desktop';
  });

  useEffect(() => {
    // Dla pewności aktualizujemy, jeśli coś się zmieniło,
    // ale zazwyczaj pierwszy strzał będzie celny.
    setDeviceType(getDeviceType());
  }, []);

  return deviceType;
};